const Home = () => {
  return (
    <div className="flex flex-col">
      <span>I am Rana & I am awesome</span>
    </div>
  );
};

export default Home;
